class editSeatplan {
    constructor(Alert, $http, $state, $stateParams) {

        this.key = 'edit-seatplan';
        this.title = 'Edit';
        this.level = 'highlight';
        this.icon = 'fal fa-edit';
        this.alert = Alert;
        this.api = $http;
        this.state = $state;
        this.back = $stateParams.back;
        this.params = $stateParams.backParams || {
            id: $stateParams.id
        };
    }

    action(seatplan, vm) {
        return this.state.go('app.seatplans.edit', {id: seatplan.id});
    }
}

angular
    .module('festzelt-os.seatplans')
    .factory('editSeatplan', [
        'Alert',
        '$http',
        '$state',
        '$stateParams',
        (Alert, $http, $state, $stateParams) => new editSeatplan(Alert, $http, $state, $stateParams)
    ]);




// WEBPACK FOOTER //
// ./src/app/pages/seatplans/workflows/edit-seatplan.js